<template>
  <div>
    <span v-if="type !== 'see'" class="iv-main-color iv-main-hover-color iv-operate-item iv-pull-left iv-pointer uit-add-list" @click="expandParent('edit', item)">
      编辑 
    </span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      type: this.$decode(this.$route.query.type)
    }
  },
  inject: {
    expandParent: {
      default () {
        return function () {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .ivu-poptip-popper {
    left: auto !important;
    right: 1px;
    .ivu-poptip-arrow {
      margin-left: 38px !important;
    }
    .ivu-btn {
      padding: 0px 9px !important;
    }
  }
  /deep/ .ivu-poptip-confirm {
    display: inline-flex;
  }
</style>
